<template>
    <section class="quick-accordion">
        <b-card no-body>
            <b-card-header>
                <div class="flex-title-buttons" v-b-toggle="(id + '-id')">
                    <span class="flex-title" v-if="title">
                        <span class="pr-1" v-if="$slots['before-title']">
                            <slot name="before-title"></slot>
                        </span>
                        <span class="title">{{ title }}</span>
                    </span>
                    <b-button class="quick-accordion__button" variant="white">
                        <b-icon-chevron-down></b-icon-chevron-down>
                    </b-button>
                </div>
            </b-card-header>
            <b-collapse :id="(id + '-id')" class="mt-2" v-model="internalVisible">
                <div class="p-3">
                    <slot></slot>
                </div>
            </b-collapse>
        </b-card>
    </section>
</template>
<script>
import { BIconChevronDown } from 'bootstrap-vue';

export default {
    components: {
        BIconChevronDown,
    },
    props: {
        id: {
            required: true,
        },
        title: {
            required: false,
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        visible: {
            immediate: true,
            handler(value) {
                this.internalVisible = value;
            },
        },
    },
    data() {
        return {
            internalVisible: false,
        };
    },
    mounted() {
        this.$parent.$on('closeAccordion', (id) => {
            if (id && id !== this.id) {
                return;
            }
            this.internalVisible = false;
        });
    },
    methods: {
        getClasses(icon, color) {
            return [`icon-${icon}`, `text-${color}`, 'ml-10'].join(' ');
        },
        open() {
            this.internalVisible = true;
        },
        close() {
            this.internalVisible = false;
        },
    },
};
</script>
<style scoped>
::v-deep .card {
    border: none;
}
.flex-title-buttons {
    display: grid;
    justify-content: space-between;
    align-items: center;
    grid-template-columns: 1fr 80px;
    width: 100%;
    line-height: 1;
    padding-left: 0.5rem;
}

.flex-combo-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.bi-chevron-down {
    transform: scale(0.75);
}

.not-collapsed .bi-chevron-down {
    transform: rotate(180deg) scale(0.75);
}

.quick-accordion__button {
    width: min-content;
    margin-left: auto;
}

.quick-accordion .card-header {
    padding: 0.25rem;
    border-bottom: 1px solid #dfdfdfad;
}
.flex-title .title {
    font-weight: 500;
}
</style>
